import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'
import Stack from '@mui/material/Stack'
import ChecklistIcon from '@mui/icons-material/Checklist'
import PetsIcon from '@mui/icons-material/Pets'
import BedroomParentIcon from '@mui/icons-material/BedroomParent'
import KeyIcon from '@mui/icons-material/Key'
import CreateIcon from '@mui/icons-material/Create'
import ChairIcon from '@mui/icons-material/Chair'
import CategoryIcon from '@mui/icons-material/Category'
import InfoIcon from '@mui/icons-material/Info'
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt'
import BuildIcon from '@mui/icons-material/Build'
import PersonIcon from '@mui/icons-material/Person'
import { useParams, useLocation, Link } from 'react-router-dom'
import { useUserRoles } from '@services/token/token.hooks'
import KitchenIcon from '@mui/icons-material/Kitchen'

// Menu items for protocols
const protocolsMenuItem = { text: 'Protokoły', icon: <ChecklistIcon />, to: '/' }

// Menu item for client management
const clientManagementMenuItem = {
  text: 'Zarządzanie klientami',
  icon: <PersonIcon />,
  to: '/clients'
}

// Menu item for helpdesk
const helpdeskMenuItem = { text: 'Helpdesk', icon: <BuildIcon />, to: '/helpdesk/tickets' }

// Submenu items for protocols
const secondaryListItems = [
  { text: 'Ogólne informacje', icon: <InfoIcon />, to: '#info' },
  { text: 'Meble', icon: <ChairIcon />, to: '#furniture' },
  { text: 'Przedmioty', icon: <CategoryIcon />, to: '#items' },
  { text: 'Klucze', icon: <KeyIcon />, to: '#keys' },
  { text: 'Liczniki', icon: <ElectricBoltIcon />, to: '#meters' },
  { text: 'Pokoje', icon: <BedroomParentIcon />, to: '#rooms' },
  { text: 'Sprzęt AGD', icon: <KitchenIcon />, to: '#protocolHouseholdAppliances' },
  { text: 'Meble (Nowe)', icon: <ChairIcon />, to: '#protocolFurnitures' },
  { text: 'Zwierzęta', icon: <PetsIcon />, to: '#animals' },
  { text: 'Podpis', icon: <CreateIcon />, to: '#signature' }
]

export default function MenuContent() {
  const { id } = useParams()
  const { hash, pathname } = useLocation()
  const { isTechnician } = useUserRoles()

  // Check if we are in the helpdesk section
  const isHelpdeskSection = pathname.startsWith('/helpdesk')
  // Check if we are in the clients section
  const isClientsSection = pathname.startsWith('/clients')

  // Determine menu items based on user role
  const mainListItems = isTechnician()
    ? [helpdeskMenuItem] // Only helpdesk for technicians
    : [protocolsMenuItem, clientManagementMenuItem] // Protocols and client management for regular users

  return (
    <Stack sx={{ flexGrow: 1, p: 1, gap: 2 }}>
      <List dense>
        {mainListItems.map((item) => (
          <ListItem key={item.to} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={
                item.to === '/'
                  ? pathname === '/' ||
                    (pathname.includes('/') && !isHelpdeskSection && !isClientsSection)
                  : pathname.startsWith(item.to)
              }
              component={Link}
              to={item.to}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      {!!id && !isHelpdeskSection && !isClientsSection && !isTechnician() && (
        <List
          dense
          subheader={
            <ListSubheader sx={{ background: 'transparent', fontWeight: 600 }}>{id}</ListSubheader>
          }
        >
          {secondaryListItems.map((item) => (
            <ListItem key={item.to} disablePadding sx={{ display: 'block' }}>
              <ListItemButton component={Link} to={`/${id}${item.to}`} selected={hash === item.to}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </Stack>
  )
}
